import { render } from "./SavedFiltersDropDownListOption.vue?vue&type=template&id=2cd11fba&scoped=true"
import script from "./SavedFiltersDropDownListOption.vue?vue&type=script&lang=js"
export * from "./SavedFiltersDropDownListOption.vue?vue&type=script&lang=js"

import "./SavedFiltersDropDownListOption.vue?vue&type=style&index=0&id=2cd11fba&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cd11fba"]])

export default __exports__